/**
 * TanStack Query staleTime for dashboard TRPC aggregates (job ads list, submitted leads).
 * The app QueryClient uses default staleTime 0, so without this every remount/window
 * focus treats data as stale and refetches.
 */
export const DASHBOARD_TRPC_STALE_MS = 60_000;
